export enum PlatformApplications {
	AdminPanel = 22,
	BES = 29,
	PlanoHero = 30,
	DataConsole = 32,
	Builder = 36,
	BI = 42,
	Connector = 51
}